import { useState } from 'react';
import clsx from 'clsx';

import { Icon, IconButton } from '@atom/mui';
import { KeyboardArrowDownIcon, KeyboardArrowUpIcon } from '@atom/mui/icons';
import colors from '@atom/styles/colors';
import { AttributesType, DetailAttributeGroupsItem } from '@atom/types/schema';

import AttributeRow from './AttributeRow';

import classes from './inventoryExportDetail.module.css';

interface Props {
  attributeGroup: DetailAttributeGroupsItem;
  attributeFilters: { [key: string]: string[] };
  selectedAttributes: Set<string>;
  onAttributeToggle: (id: string) => void;
  onAttributeFiltersChange: (id: string, filters: string[]) => void;
  isDisabled: boolean;
}

const AttributeGroupRow = ({
  attributeGroup,
  attributeFilters,
  selectedAttributes,
  onAttributeToggle,
  onAttributeFiltersChange,
  isDisabled,
}: Props) => {
  const [open, toggleOpen] = useState(true);

  const icon = open ? KeyboardArrowUpIcon : KeyboardArrowDownIcon;
  return (
    <>
      <div className={classes.attributeGroupHeader}>
        <div>{attributeGroup.name}</div>
        <IconButton onClick={() => toggleOpen(!open)}>
          <Icon color={colors.neutral.gray} icon={icon} />
        </IconButton>
      </div>
      <div className={clsx(classes.attributeSection, open && classes.open)}>
        {attributeGroup.attributes.map((attribute: AttributesType) => (
          <AttributeRow
            key={attribute.id}
            attribute={attribute}
            filters={attributeFilters[attribute.id] || []}
            onAttributeToggle={onAttributeToggle}
            onAttributeFiltersChange={onAttributeFiltersChange}
            isChecked={selectedAttributes.has(attribute.id)}
            isDisabled={isDisabled}
          />
        ))}
      </div>
    </>
  );
};

export default AttributeGroupRow;
